import { IApiGroupMappingType } from 'api/interfaces/data-contracts';

export interface IAccountCategoryTypeProps {
  groupMappingType: IApiGroupMappingType;
  investorId: number | null;
  masterId: number | null;
}

export interface IAccountCategoryType {
  isInvestorAccount: boolean;
  isMasterAccount: boolean;
  isCommissionAccount: boolean;
  isMamCommissionAccount: boolean;
  isCopyTradingAccount: boolean;
  isInMamInvestorGroupMappingType: boolean;
}

export const getAccountCategoryType = (accountInfo: IAccountCategoryTypeProps): IAccountCategoryType => {
  const { groupMappingType, masterId, investorId } = accountInfo;

  const isInvestorAccount =
    [IApiGroupMappingType.RealCopyTradingInvestorStandard, IApiGroupMappingType.RealCopyTradingInvestorEcn].includes(
      groupMappingType,
    ) && investorId != null;

  const isMasterAccount =
    [IApiGroupMappingType.RealCopyTradingMasterEcn, IApiGroupMappingType.RealCopyTradingMasterStandard].includes(
      groupMappingType,
    ) && masterId != null;

  const isCommissionAccount = [
    IApiGroupMappingType.RealCommissionStandard,
    IApiGroupMappingType.RealCommissionEcn,
  ].includes(groupMappingType);

  const isMamCommissionAccount = [
    IApiGroupMappingType.RealMamCommissionStandard,
    IApiGroupMappingType.RealMamCommissionEcn,
  ].includes(groupMappingType);

  const isCopyTradingAccount = isInvestorAccount || isMasterAccount;

  const isInMamInvestorGroupMappingType = [
    IApiGroupMappingType.RealMamInvestor,
    IApiGroupMappingType.RealMamInvestorEcn,
  ].includes(groupMappingType);

  return {
    isInvestorAccount,
    isMasterAccount,
    isCommissionAccount,
    isMamCommissionAccount,
    isCopyTradingAccount,
    isInMamInvestorGroupMappingType,
  };
};
